import CameraControls from "camera-controls";
import { Vector3 } from "three";

import { Context } from "../../../../context";
import { ControllerStrategy } from "../../strategy";
import { TrackingControllerStrategy } from "../tracking";
import { disableContextMenu } from "../../../../../lib/misc/util";

export class LookAtControllerStrategy extends TrackingControllerStrategy {
  private target: Vector3 = new Vector3();
  private pos: Vector3 = new Vector3();
  private temp: Vector3 = new Vector3();
  private dir: Vector3 = new Vector3();

  private followOffCb = () => {
    this.targetDist = this.pos.distanceTo(this.target);
    if (this.registered) this.registered.state.following = false;
  };
  private followOnCb = () => {
    this.registered?.controls?.getTarget(this.target);
    this.registered?.controls?.getPosition(this.pos);

    this.target.sub(this.pos).setLength(this.targetDist).add(this.pos);

    if (this.registered) this.registered.state.following = true;
  };

  private camDist = 0.00001;
  private targetDist = 10;

  init(context: Context): ControllerStrategy {
    super.init(context);

    if (!this.registered) {
      console.error("no controller registered");
      return this;
    }

    // this.registered.state.following = true;

    const { controls, domRef } = this.registered;

    if (controls) {
      controls.getPosition(this.pos);
      controls.getTarget(this.target);

      this.dir.copy(this.target).sub(this.pos).setLength(this.camDist);

      controls.mouseButtons.right = CameraControls.ACTION.NONE;

      // TODO: improve this - assumes we're combining this with the zoomFOV strategy
      controls.touches.two = CameraControls.ACTION.TOUCH_ZOOM;
    } else {
      console.error("no controls to take over");
    }

    domRef.addEventListener("contextmenu", disableContextMenu);
    domRef.addEventListener("pointerdown", this.followOffCb);
    domRef.addEventListener("pointerup", this.followOnCb);
    domRef.addEventListener("pointerleave", this.followOnCb);

    return this;
  }

  update(_deltaS: number, _gameTimeDelta: number, frameNum?: number) {
    const context = this.registered?.contextRef;
    const controls = this.registered?.controls;
    const tracked = this.registered?.state.tracked;

    if (!this.registered || !tracked || !context || !controls) {
      return;
    }

    if (this.registered.state.following) {
      this.temp.copy(tracked.position);

      // TODO: make this frame rate invariant
      this.target.lerp(this.temp, 0.1);

      controls.getPosition(this.pos);

      this.dir
        .subVectors(this.target, this.pos)
        .setLength(this.camDist)
        .add(this.pos);
      controls.setTarget(this.dir.x, this.dir.y, this.dir.z, false);
    }

    if (frameNum != undefined) this.lastFrameNum = frameNum;
  }

  teardown() {
    super.teardown();

    if (!this.registered) return;

    const { controls, domRef } = this.registered;
    if (controls) {
      controls.setLookAt(
        this.pos.x,
        this.pos.y,
        this.pos.z,
        this.target.x,
        this.target.y,
        this.target.z,
        true
      );
      // controls.setTarget(this.target.x, this.target.y, this.target.z, true);

      controls.mouseButtons.right = CameraControls.ACTION.TRUCK;
    }

    domRef.removeEventListener("contextmenu", disableContextMenu);

    if (this.followOffCb && this.followOnCb) {
      domRef.removeEventListener("pointerdown", this.followOffCb);
      domRef.removeEventListener("pointerup", this.followOnCb);
      domRef.removeEventListener("pointerleave", this.followOnCb);
    }
  }
}
